module.exports = function anonymous(it
/**/) {
var out='<li data-filter-built class="filter__item"> <a href="#" data-filter-archive-toggle>Archive</a> <div class="filter__item__archives" data-filter-archive> <ul> ';var arr1=it;if(arr1){var item,index=-1,l1=arr1.length-1;while(index<l1){item=arr1[index+=1];out+=' <li data-value="'+(item.Value)+'" class="filter__item is-archive';if(item.Selected){out+=' is-current';}out+='" data-filter-item-option> <a href="#">'+(item.Text)+'</a> </li> ';} } out+=' </ul> </div></li>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/filterArchive.dot
// module id = 247
// module chunks = 0 1